import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  display: flex;
  justify-content: ${({ justify }) => justify};
  align-items: center;
  flex-direction: column;
  margin-bottom: 1rem;
  box-sizing: border-box;

  > * {
    margin-bottom: 1rem;
  }

  ${breakpoint("tablet")`
    flex-direction: row;

    & > :not(:last-child) {
      margin-right: 1rem;
    }

    > * {
      margin-bottom: 0;
    }
  `}
`
